import { createSlice } from '@reduxjs/toolkit'

interface ExperienceState {
  loading: boolean // 씬 로딩 상태
  rubbishes: any[] // 씬 내 쓰레기 객체 배열
}

const initialState: ExperienceState = {
  loading: true, // 씬이 맨처음 초기 로딩 상태가 true
  rubbishes: [], // 초기 씬 내 쓰레기는 비어있음
}

const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    /** 페이지 상태 초기화 */
    initExperienceStateAction: (state) => {
      Object.assign(state, initialState)
    },
    /** 씬 로딩 상태 설정 */
    setSceneLoadedAction: (state, { payload }) => {
      state.loading = payload
    },
    /** 씬 내 쓰레기 추가 */
    addSceneRubbish: (state, { payload }) => {
      state.rubbishes.push(payload)
    },
    /** 씬 내 특정 쓰레기 제거 */
    removeSceneRubbish: (state, { payload }) => {
      const { id } = payload
      state.rubbishes = state.rubbishes.filter((rubbish) => rubbish.id !== id)
    },
  },
})

export const { initExperienceStateAction, setSceneLoadedAction, addSceneRubbish, removeSceneRubbish } =
  experienceSlice.actions

export default experienceSlice.reducer
